module.exports = __webpack_public_path__ + "img/14.9ef1b399.jpg";